import http from './http';

// 获取支付方式
// const fetchPayTypes = (params) => {
//   return http({
//     url: '/payment/type',
//     params,
//   });
// };

// 获取支付方式
const fetchPayTypes = (params) => {
  return http({
    url: `/payment/type/business/${params.businessType}`,
  });
};

// 获取所有OTA渠道
const fetchAllOta = () => {
  return http({
    url: '/payment/type/ota',
  });
};

// 支付
const pay = (data) => {
  return http({
    url: '/pay',
    method: 'POST',
    data,
  });
};

// 退款
const refund = (data) => {
  return http({
    url: '/pay/refund',
    method: 'POST',
    data,
  });
};

// 会员充值
const recharge = (data) => {
  return http({
    url: '/recharge',
    method: 'POST',
    data,
  });
};

// 获取交易结果
const fetchTransactionResult = (params) => {
  return http({
    url: `/transactions/${params.orderNo}/status`,
  });
};

// 根据身份证号获取会员信息
const fetchVipInfoByCertNo = (params) => {
  return http({
    url: '/customers/cert_no',
    params,
  });
};

// 根据会员码获取会员信息
const fetchVipInfoByBarcode = (params) => {
  return http({
    url: '/customers/scan-code',
    params,
  });
};

// 获取订单号获取房主会员信息
const fetchVipInfoByOrderNo = (params) => {
  return http({
    url: `/order/detail/master/${params.resvNo}`,
  });
};

// 查询会员相关业务是否启用
const fetchMemberBusinessInfo = () => {
  return http({
    url: '/payment/type/business/member/info',
    method: 'GET',
  });
};

// 根据身份证号获取选住余额信息
const fetchXuanzhuBalanceByCertNo = (params) => {
  return http({
    url: `/xuanzhu/balance`,
    params,
  });
};

// 根据wyuId查询选住余额信息
const fetchXuanzhuBalanceByWyuId = (params) => {
  return http({
    url: `/xuanzhu/queryByWyuid`,
    params,
  });
};

export {
  fetchPayTypes,
  fetchAllOta,
  pay,
  refund,
  recharge,
  fetchTransactionResult,
  fetchVipInfoByCertNo,
  fetchVipInfoByBarcode,
  fetchVipInfoByOrderNo,
  fetchMemberBusinessInfo,
  fetchXuanzhuBalanceByCertNo,
  fetchXuanzhuBalanceByWyuId,
};
